import _debounce from 'lodash/debounce';
import toggleModal from '@/scripts/utils/toggle-modal';
import breakpoints from '@/scripts/utils/_breakpoints';
import imagesLoaded from 'imagesloaded/imagesloaded.pkgd.min';
import createEvent from '@/scripts/utils/create-event';
import swiperSliderInit from '@/scripts/lib/swiper-slider';
import { TweenLite } from 'gsap/TweenLite';
import './PageFilters.scss';


const defaults = {
  element: null,
  form: '[data-role*="page-filters-form"]',
  input: 'input',
  resetButton: '[data-role*="reset-button"]',
  triggerButton: '[data-role*="trigger-button"]',
  formScrollContainer: '[data-role*="form-scroll-container"]',
  itemsContainer: '[data-container="ajax-items-list"]',
  loadButton: '[data-role="load-more-items"]',
};

export default class PageFilters {
  constructor(props) {
    const options = Object.assign({}, defaults, props);
    if (!options.element) return;
    this.element = options.element;
    this.form = this.element.querySelector(options.form);
    this.inputs = Array.from(this.form.querySelectorAll(options.input));
    this.resetButton = this.form.querySelector(options.resetButton);
    this.formScrollContainer = options.formScrollContainer;
    this.triggerButtons = Array.from(this.element.querySelectorAll(options.triggerButton));
    this.itemsContainer = this.element.querySelector(options.itemsContainer);
    this.loadButton = this.element.querySelector(options.loadButton);
    this.activeClass = 'is-active';
    this.loadingClass = 'is-loading';
    this.transitionDuration = document.documentElement.dataset.duration;
    this.init();
  }

  onReset(e) {
    if (e) e.preventDefault();
    this.inputs.forEach((input) => { input.checked = false; }); // eslint-disable-line no-param-reassign
    if (window.innerWidth <= breakpoints.lg) this.onTrigger();
    return this.onSubmit();
  }

  onTrigger() {
    document.documentElement.classList.toggle('filters-opened');
    this.form.classList.toggle(this.activeClass);
    return toggleModal(this.form.classList.contains(this.activeClass), this.formScrollContainer, this.form);
  }

  onSubmit(e) {
    if (e) e.preventDefault();
    const $form = $(this.form);
    // set element loading
    this.element.classList.add(this.loadingClass);
    if (this.loadButton) {
      this.loadButton.dataset.num = 0;
    }
    // ajax to receive new data
    $.ajax({
      url: $form.attr('action'),
      type: $form.attr('method'),
      data: {
        formParams: $form.serialize(),
        num: this.loadButton && this.loadButton.dataset.num++ || 0, // eslint-disable-line no-plusplus
      },
      success: (result) => {
        if (result) {
          $(this.itemsContainer).html(result);
          PageFilters.initSliders();
          this.scrollToTop();
          imagesLoaded(this.itemsContainer, () => {
            this.removeLoadingClass();
            window.dispatchEvent(createEvent('resize'));
          });
        } else {
          this.removeLoadingClass();
        }
      },
      error: () => this.removeLoadingClass(),
    });

    // replace it with callback after ajax request, it's just a demo
  }

  removeLoadingClass() {
    setTimeout(() => this.element.classList.remove(this.loadingClass), 1000);
  }

  static initSliders() {
    swiperSliderInit({
      slidesPerView: 1,
      spaceBetween: 0,
      selector: 'single-room',
      paginationType: 'bullets',
      pagination: true,
    });
  }

  scrollToTop() {
    return TweenLite.to(
      window,
      this.transitionDuration,
      { scrollTo: { y: $(this.itemsContainer).offset().top - 300, autoKill: false } },
    );
  }

  onLoadMoreItems() {
    if (!this.loadButton.dataset.num) {
      this.loadButton.dataset.num = 0;
    }
    const { params } = this.loadButton.dataset;
    const { type, url } = JSON.parse(params);
    const $form = $(this.form);
    this.loadButton.classList.add('loading');
    $.ajax({
      type,
      url,
      data: {
        formParams: $form.serialize(),
        num: this.loadButton.dataset.num++, // eslint-disable-line no-plusplus
      },
      success: (result) => {
        if (result) {
          $(this.itemsContainer).append(result);
          PageFilters.initSliders();
          imagesLoaded(this.itemsContainer, () => {
            this.loadButton.classList.remove('loading');
            window.dispatchEvent(createEvent('resize'));
          });
        } else {
          this.loadButton.classList.add('is-disabled');
        }
      },
      error: () => {
        this.loadButton.classList.add('is-disabled');
      },
    });
  }

  init() {
    this.form.addEventListener('submit', this.onSubmit.bind(this));
    if (this.loadButton) this.loadButton.addEventListener('click', this.onLoadMoreItems.bind(this));
    this.resetButton.addEventListener('click', this.onReset.bind(this));
    this.triggerButtons.forEach(triggerButton => triggerButton.addEventListener('click', this.onTrigger.bind(this)));
    this.inputs.forEach(input => input.addEventListener('change', _debounce(this.onSubmit.bind(this), 100)));
    if (this.itemsContainer.dataset.getContentOnload) {
      this.onSubmit();
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/lib/PageFilters/PageFilters.js